var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div class=\"row\"><div class=\"col-md-6\"><h4 class=\"m-t-0 inline-block\">Invoice: {{::$ctrl.invoice.id}} <small>{{::$ctrl.invoice.transactionType}}</small></h4></div><div class=\"col-md-6 text-md-right\"><p class=\"m-a-0\"><strong>Status:&nbsp;</strong> <span ng-if=\"$ctrl.invoice.status\" class=\"float-none label label-primary\">{{ $ctrl.invoice.status }}</span></p></div></div>";
var id1="invoice-heading.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;